import { TaskEither } from 'fp-ts/TaskEither';
import { fetchTE, fetchApi } from 'utils/request';
import { toQueryParams } from 'api/apiUtils';

export const listDeploymentsTE = <E = CF.API.ApiError>(
  {
    userId,
    nodePoolId,
    modelVersionIds,
  }: {
    userId: string;
    nodePoolId?: string;
    modelVersionIds?: string[];
  },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ListDeploymentsResponse> =>
  fetchTE<CF.API.Compute.ListDeploymentsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/deployments${nodePoolId ? '?nodepool_id='.concat(nodePoolId) : ''}${
        modelVersionIds ? `?${toQueryParams(modelVersionIds, 'model_version_ids')}` : ''
      }`,
      method: 'GET',
    },
    onRejected,
  );

export const apiListDeployments = ({
  userId,
  nodePoolId,
  modelVersionIds,
}: {
  userId: string;
  nodePoolId?: string;
  modelVersionIds?: string[];
}): Promise<CF.API.Compute.ListDeploymentsResponse> =>
  fetchApi<CF.API.Compute.ListDeploymentsResponse>({
    path: `/api/_api/v2/users/${userId}/deployments${nodePoolId ? '?nodepool_id='.concat(nodePoolId) : ''}${
      modelVersionIds ? `?${toQueryParams(modelVersionIds, 'model_version_ids')}` : ''
    }`,
    method: 'GET',
  });

export const listAllDeploymentsTE = <E = CF.API.ApiError>(
  { userId }: { userId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ListDeploymentsResponse> =>
  fetchTE<CF.API.Compute.ListDeploymentsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/deployments`,
      method: 'GET',
    },
    onRejected,
  );

export const apiListAllDeployments = ({ userId }: { userId: string }): Promise<CF.API.Compute.ListDeploymentsResponse> =>
  fetchApi<CF.API.Compute.ListDeploymentsResponse>({
    path: `/api/_api/v2/users/${userId}/deployments`,
    method: 'GET',
  });
